module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('span', {
    staticClass: "litblue"
  }, [_c('b', [_vm._v("COMFORT KNITTING & CROCHET")])])])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Babies & Toddlers")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("50 knit and crochet designs using"), _c('br'), _vm._v("Berroco’s Comfort and Vintage yarns")])]), _vm._v(" "), _c('p', {
    staticClass: "centert1a"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Norah Gaughan and the Berroco Design Team")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Photographs by Ericka McConnell"), _c('br'), _vm._v("Photostyling by Danielle Gold")])]), _vm._v(" "), _c('p', {
    staticClass: "centert1s"
  }, [_c('span', {
    staticClass: "ash"
  }, [_vm._v("STC CRAFT | A MELANIE FALICK BOOK"), _c('br'), _vm._v("STEWART, TABORI & CHANG"), _c('br'), _vm._v("NEW YORK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc2c19b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Title.vue
// module id = 63
// module chunks = 0